<template>
    <div class='news-wrapper'>
        <div class='left-list scroll' ref=parent>
            <List :detail='model' v-model='selectArticle' @change='handleSelectChange' />
        </div>
        <div class='right-content scroll' ref='articlceWrap'>
            <Article ref='newsContent' />
        </div>
    </div>
</template>

<script>
//这段代码未知，一直没碰过；
import Article from '@/pages/components/article';
import List from '@/pages/components/historic_records_list';

// import * as client from '@/common/js/client'
import * as actions from '@/common/js/api'
export default {
    name: 'tags',
    data() {
        return {
            selectArticle: {},
            // hasLeft: true,
            // model: {
            //     code: "300033",
            //     end: "0",
            //     industry: "",
            //     market: "17",
            //     objid: "284966816",
            //     period: "-1",
            //     start: "0",
            //     tagtype: "undefined",
            //     time: "0",
            //     treeid: "14375",
            //     treeids: "14370,14375,14374,14364",
            //     type: "news",
            // },

        }
    },
    props: ['model'],
    provide() {
        return { pageDetail: { ...this.model } }
    },
    components: {
        Article,
        List
    },
    computed: {
        hasLeft() {
            return this.model.treeid
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        // console.log( this.model)
    },
    mounted: function () {
    },
    methods: {
        handleSelectChange(e) {
            this.selectArticle = e;
            this.$nextTick(res => {
                this.$refs.newsContent.initData(e);
            }

            )
        },
        filterId(obj) {
            return obj.id || obj.seq;
        },
        setBaseInfo(e) {
            this.model = e;
        },
        getCollectInfo(e) {
            return {
                title: '',
                data: '',
                sourceId: 7,
                url: 'www',
                stock: ''
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../common/page_common.less';
</style>
